import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaFileUploadUndo from './VaFileUploadUndo.vue'

export const VaFileUploadUndo = withConfigTransport(_VaFileUploadUndo)
